<template>
    <div class="container has-text-light">
        <div v-show="$root.app.userAttrs.bundleLimit == null || $root.app.userAttrs.bundleLimit < 1">
            <br>
                <div class="has-text-left top20 is-size-2">COLLAB NETWORK</div>
                <div>To add a connection enter their email address below and click the plus sign:</div>
                <div class="has-background-dark connectsControl">
                    <div class="connectInput"><input type="text" class="input darkInput" placeholder="enter email address" ref="email" @keyup="keyup"/></div><div class="plusButton handCursor"  @click="addConn">+</div>
                </div>
    
                <div  class="wideLimitWidth top20">
                    <table width="100%">
                        <tr>
                            <td>
                                <b>User</b>
                            </td>
                             <td>
                                <b>Status</b>
                            </td>
                             <td>
                                <b>Handle</b>
                            </td>
                             <td>
                                <b>&nbsp;</b>
                            </td>
                        </tr>
    
                        <tr class="connectRow" v-for="(item, i) in conns" :key="i">
                            <td>
                                <span v-if="item.id_recip == true && item.meOrig">&nbsp;{{item.fName + ' ' + item.lName}}</span>
    
                                <span v-if="!item.meOrig">&nbsp;{{item.origF + ' ' + item.origL}}</span>
    
                                <span v-if="item.id_recip == false">&nbsp;{{item.toEmail}}</span>
                            </td>
                             <td>
                                {{statusCheck(item.active, item.blockedBy, item.meOrig)}}
                            </td>
                            <td>
                                <b class="handCursor has-text-light" @click="goToProfile(item.handle)">{{item.handle}}</b>
                            </td>
                              <td>
                                <button ref="multiButt" class="button is-small is-coolGreen" @click="act(item.id, 'accept', i)">{{forButton(item.active, item.blockedBy, item.meOrig)}}</button>
                                <button v-if="item.active == 0 && item.meOrig == false" class=" button is-small is-coolGreen" @click="act(item.id, 'decline', i)">DECLINE</button>
                            </td>
                        </tr>
    
                    </table>
                    <div v-if="conns.length == 0" class="top20 yellowBorderTitle"><b class="has-background-dark">You have no connections yet.</b></div>
                    <div id="lister" class="top40">&nbsp;</div>
                </div>
            <br>
        </div>
        <div v-if="$root.app.userAttrs.bundleLimit > 0 && $root.app.checkLimits">
            <div class="is-size-3 top40">User is on a free plan, must upgrade to use Collabs -- Need text for this section</div>
        </div>
    </div>
</template>

<script>
 
import { AZEventBus } from '../components/AZEventBus'
export default{
    data: function(){
        return {
            inited: false,
            conns: []
        }
    },

    mounted: function(){
       
    var self = this
       


    function init(){
           function w(d){
               az.addRemSpinner(false, 'id', 'lister')
                self.conns = d.r
            }
            function n(){
                az.addRemSpinner(false, 'id', 'lister')
            }
            az.addRemSpinner(true, 'id', 'lister')
            self.$root.app.apiClient.get('subs/conn', {}, w, n)
      }

    if(self.$root.app.doneFederating){
        self.inited = true
        init();
    }

      AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
                init();
      });
    },

    methods: {
        addConn: function(){
           let v = this.$refs.email.value.toLowerCase()
           let err = false

           let arr = v.split('@')

           if(arr.length != 2){
               err = true
           } else {
               let s = arr[1].split('.')

               if(s.length < 2){
                   err = true
               }
           }

           if(err){
                this.$root.app.showModalOK({message: 'Please enter a valid email address'})
           } else {


                var inList = false

                this.conns.forEach(e => {
                    if(e.toEmail == this.$refs.email.value){
                        inList = true
                    }
                })

                if(inList){
                    this.$root.app.showModalOK({message: 'The email you are trying to add belongs to a user who is already in your Connects list.'})
                    return
                }

                this.$root.app.doShowModal('ModalConnectsInvite', {callback: this.doConn})
           }
        },

        doConn: function(){
            var self = this

           

            function w(d){
                self.$root.app.closeModal();

                if(d.r.s == 'pending'){
                    self.$root.app.showModalOK({message: 'You already have a pending request with this user.'})                    
                } else if(d.r.s == 'active'){
                    self.$root.app.showModalOK({message: 'You already have an active connection with this user.'})   
                } else if(d.r.s == 'self'){
                    self.$root.app.showModalOK({message: 'You may not connect to yourself.'})   
                } else if(d.r.action == 'emailSent'){
                    self.$refs.email.value = ''
                    self.$root.app.showModalOK({message: 'An invitation has been sent to the user.'})  
                } else if(d.r.action == 'emailInvite'){
                    self.$root.app.showModalOK({message: 'An invitation email has been sent to the email you provided.'})  
                }

                let id = d.r.insertId

                if(d.r.action == 'emailSent' || d.r.action == 'emailInvite'){
                    self.conns.unshift({
                        toEmail: self.$refs.email.value,
                        active: 0,
                        meOrig: true,
                        blockedBy: null,
                        id: id,
                        id_recip: true,
                        fName: d.r.fName,
                        lName: d.r.lName
                    })
                }
            }

            function n(){

            }

            this.$root.app.apiClient.post('subs/conn', {email: self.$refs.email.value.toLowerCase()}, w, n)
        },

        statusCheck: function(active, bb, meOrig){
            if(active == 0){
                if(meOrig) {
                    return 'PENDING'
                } else {
                    return 'INCOMING'
                }
            } else if((bb == 1 && meOrig) || bb == 3){
                return 'BLOCKED'
            } else if((bb == 2 && !meOrig)){
                return 'BLOCKED'
            } else {
                return 'CONNECTED'
            }
        },

        forButton: function(active, bb, meOrig){
            if(active == 0){
                if(meOrig) {
                    return 'CANCEL'
                } else {
                    return 'ACCEPT'
                }
            } else if(bb == 1 && meOrig){
                return 'UNBLOCK'
            } else if(bb == 2 && !meOrig){
                return 'UNBLOCK'
            } else if(bb == 3) {
                return  'UNBLOCK'
            } else if(bb == 2 && meOrig){
                return 'BLOCK'
            } else if(bb == 1 && !meOrig){
                return 'BLOCK'
            } else if(bb == 0){
                return 'BLOCK'
            }
        },

        goToProfile: function(p){
            this.$router.push({name: 'profiledelegate', params: {propProfile: p}})
        },

        act: function(id, val, i){
           
            var self = this
            if(this.$refs.multiButt[i].innerText == 'BLOCK' || this.$refs.multiButt[i].innerText == 'UNBLOCK'){

                let a = this.$refs.multiButt[i].innerText == 'BLOCK' ? 'b' : 'u'

                function w(d){
                    if(d.r == 'ok'){
                        let c = self.conns.find(e => {
                            return e.id == id
                        })
              
                        c.blockedBy = d.a
                    }
                }

                function n(){

                }
                this.$root.app.apiClient.put('subs/conn/block', {id: id, a: a}, w, n)


            } else if(this.$refs.multiButt[i].innerText == 'CANCEL'){
                function w(d){
                    if(d.r == 'ok'){
                       let i = self.conns.findIndex(e => {
                            return e.id == id
                        })

                        self.conns.splice(i, 1)
                    }
                }

                function n(){

                }
                this.$root.app.apiClient.put('subs/conn/cancel', {id: id}, w, n)

            } else if(val == 'accept' || val == 'decline'){
                let a = val == 'accept' ? 'a' : 'd'

                function w(d){
                    if(d.r == 'ok'){
                        if(a == 'a'){
                            let c = self.conns.find(e => {
                                return e.id == id
                            })

                            c.active = 1
                            c.accepted = 1
                        } else {
                            let i = self.conns.findIndex(e => {
                                return e.id == id
                            })

                            self.conns.splice(i, 1)
                        }
                    }
                }

                function n(){

                }
                this.$root.app.apiClient.put('subs/conn/connectid', {id: id, a: a}, w, n)
            } 
        },

        keyup: function(ev){
            if(ev.key == 'Enter'){
                this.addConn()
            }
        }
    }, 
    
    filters: {
        statusFilter: function(val){
            if(val == 'Pending'){
                return 'CANCEL'
            } else if (val == 'Connected'){
                return 'BLOCK'
            }
        }
    }
}
</script>